import React, {useEffect, useState} from 'react';
import {validationEmail} from '../../global/validate';
import axios from 'axios';
import {useDispatch} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import {setUser} from '../../store/builder/loginSlice';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {Link, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Helmet} from 'react-helmet';
import {useForgotPasswordMutation} from '../../store/builder/inspections.api';
import {setEmail, setVerify} from '../../store/builder/forgotPasswordSlice';
import {useTranslation} from '../../hooks/useTranslation';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: {
      id: 'email',
      value: null,
      errorShow: false,
              error: t('forgotPassword.emailError'),
    },
  });
  const [forgotPassword, {data, error, isLoading, isError, isSuccess}] =
    useForgotPasswordMutation();
  const [errorHandler, setErrorHandler] = useErrorHandler([error]);

  const inputHandler = e => {
    setState(old => ({
      ...old,
      [e.target.id]: {...old[e.target.id], value: e.target.value},
    }));
  };

  // useEffect(() => {
  //   if (isSuccess) {
  //     toast.success(data?.message)
  //     dispatch(setVerify(data?.data?.verify_token))
  //     dispatch(setEmail(state.email.value))
  //     navigate('/enter-code')
  //   }
  // }, [isSuccess])

  // useEffect(() => {
  //   if (isLoading) {
  //     dispatch(setLoader(true))
  //   } else {
  //     dispatch(setLoader(false))
  //   }
  // }, [isLoading])

  const submitHandler = e => {
    e.preventDefault();
    if (validationEmail(state?.email?.value)) {
      dispatch(setLoader(true));
      // forgotPassword({email: state?.email.value})
      let body = {email: state?.email.value};
      let config = {
        headers: {
          AppVersion: '1.0.0',
          AppType: 'web',
          DeviceType: 'web',
        },
      };
      axios
        .post(
          `${import.meta.env.VITE_API_URL}auth/reset-password`,
          body,
          config,
        )
        .then(res => {
          dispatch(setVerify(res?.data?.data?.verify_token));
          dispatch(setEmail(state.email.value));
          navigate('/enter-code');
          dispatch(setLoader(false));
          toast.success(res.data.message);
        })
        .catch(err => {
          dispatch(setLoader(false));
          toast.error(err.response.data.message);
        });
    } else {
      dispatch(setLoader(false));
              toast.error(t('forgotPassword.emailError'));
    }
  };

  return (
    <div className='auth'>
      <Helmet>
        <title>{t('forgotPassword.pageTitle')}</title>
      </Helmet>
      <div className='auth__wrapper'>
        <div className='auth__left'>
          <img src='/assets/forgot-image.png' alt='bg' />
        </div>
        <div className='auth__right'>
          <div className='auth__content forgot'>
                         <h1 className='auth__title'>{t('forgotPassword.title')}</h1>
            <p className='auth__subtitle'>
                              {t('forgotPassword.subtitle')}
            </p>
            <div className='auth__form' onSubmit={submitHandler}>
              <div className='auth__field'>
                <label htmlFor='email' className='auth__label'>
                  {t('forgotPassword.email')}
                </label>
                <input
                  id='email'
                                      placeholder={t('forgotPassword.emailPlaceholder')}
                  type='text'
                  className='auth__input'
                  onChange={inputHandler}
                />
                {state?.email?.errorShow && (
                  <span className='auth__error'>{state?.email?.error}</span>
                )}
              </div>
              <button className='auth__submit' onClick={submitHandler}>
                {t('forgotPassword.sendVerificationCode')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
